import { computed } from '@nuxtjs/composition-api';
import { sharedRef, useVSFContext } from '@vue-storefront/core';
// import {
//   CustomQuery
// } from '@vue-storefront/core';
import { useApiError } from '../useApiError';

export const useCustomCoupon = (id: string): any => {
  const { set: setError } = useApiError();
  const context = useVSFContext();
  const result = sharedRef(null, `useCustomCoupon-result-${id}`);
  const error = sharedRef(null, `useCustomCoupon-error-${id}`);
  // Shared ref holding errors from the methods
  const customCouponList = async (customQuery) => {
    try {
      const res = await context.$xbuy.api.CouponList(customQuery);
      if (res && res.code === 0) {
        result.value = res.data;
        error.value = null;
      } else {
        setError(res);
        error.value = new Error(res.message);
      }
    } catch (err) {
      error.value = err;
      setError({ code: 99999, err });
    }
  };
  return {
    customCouponList: customCouponList,
    // loading: computed(() => loading.value),
    result: computed(() => result.value),
    error: computed(() => error.value)
  };
};
